export const custom_env = {
    dev: {
        api_url: 'http://127.0.0.1:8003/app_adsalsa_es.php/private/clients/',
        app_name: 'Dev Team'
    },
    'adsnet.adsalsa.com': {
        api_url: 'https://es.fabricadepremios.com/private/clients/',
        app_name: 'Adsalsa Publicidad S.L.'
    },
    'rznet.aldaniti.net': {
        api_url: 'https://rz.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'itnet.lafabbricadeipremi.com': {
        api_url: 'https://it.lafabbricadeipremi.com/private/clients/',
        app_name: 'Adsalsa Italy Branch S.L.'
    },
    'nenet.aldaniti.net': {
        api_url: 'https://ne.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'cenet.aldaniti.net': {
        api_url: 'https://ce.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'cenet.wielkanagroda.com': {
        api_url: 'https://ce.wielkanagroda.com/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'eunet.aldaniti.net': {
        api_url: 'https://eu.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'brnet.aldaniti.net': {
        api_url: 'https://br.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'frnet.aldaniti.net': {
        api_url: 'https://fr.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'frnet.aldanitinetwork.com': {
        api_url: 'https://fr.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'frnet.voicicestatoi.com': {
        api_url: 'https://fr.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'amnet.aldaniti.net': {
        api_url: 'https://am.aldaniti.net/private/clients/',
        app_name: 'Aldaniti Network S.L.'
    },
    'extranet.superquoter.com': {
        api_url: 'https://money.banksandsaving.com/private/clients/',
        app_name: 'Leads Global'
    },
    'extranet.banksandsaving.com': {
        api_url: 'https://money.banksandsaving.com/private/clients/',
        app_name: 'Leads Global'
    },
    'extranet.leads.global': {
        api_url: 'https://money.banksandsaving.com/private/clients/',
        app_name: 'Leads Global'
    },

};



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/_custom_enviroment.ts